import React from 'react';
import {Typography} from "@mui/material";
import Button from "@mui/material/Button";
import { useLocation, useNavigate } from 'react-router-dom';
import Div from "@jumbo/shared/Div";
import { Link } from 'react-router-dom';


const AccessDenied = () => {

    const location = useLocation();

    return (
        <Div sx={{
            flex: 1,
            flexWrap: 'wrap',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: theme => theme.spacing(4),
        }}>
            <Div sx={{display: 'flex', justifyContent: 'center',mb: 3}}>
                <img src={"/images/restricted-area.png"} alt="Access Denied" width="20%"/>
            </Div>
            <Typography align={"center"} component={"h2"} variant={"h1"} color={"text.secondary"} mb={3}>
            Permission Denied: You do not have the necessary access rights to view this page.
            </Typography>

            <Link to={location.pathname.includes("superadmin") ? `/superAdmin/login `: `/login`}>
            <Button variant="contained">Go to home</Button>
            </Link>
        </Div>
    );
};

export default AccessDenied;
